export const assetImages = {
    loginUserIcon: "../../assets/images/login_user.png",
    logo: "/assets/images/h5logo.png",
}
